import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { List, X } from "@phosphor-icons/react";
import { useDiagnostic } from "@/context/DiagnosticContext";

const links = [
  { label: "Sectores", to: "/#sectores" },
  { label: "Servicios", to: "/#servicios" },
  { label: "Planes", to: "/#planes" },
  { label: "Nosotros", to: "/#nosotros" },
  { label: "Ayuda", to: "/#ayuda" },
  { label: "Blog", to: "/blog" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { openDiagnostic } = useDiagnostic();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      const id = to.slice(2);
      if (window.location.pathname !== "/") { navigate("/"); setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300); }
      else document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else navigate(to);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled ? "bg-white/70 backdrop-blur-xl border-b border-black/5 py-4" : "bg-transparent py-6"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-24 flex items-center justify-between">
        <button data-testid="logo" onClick={() => go("/")} className="flex items-baseline gap-1 group">
          <span className="font-serif text-2xl md:text-[28px] tracking-tight text-ink">DOMMAR</span>
          <span className="font-sans text-[10px] tracking-[0.25em] uppercase text-faint mb-1">STUDIO</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-${l.label.toLowerCase()}`}
              onClick={() => go(l.to)}
              className="font-sans text-sm text-subtle hover:text-ink transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-ink hover:after:w-full after:transition-[width] after:duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta"
            onClick={() => openDiagnostic()}
            className="font-sans text-sm px-5 py-2.5 rounded-full bg-ink text-stone-50 hover:bg-black transition-colors duration-300"
          >
            Hablemos
          </button>
        </nav>

        <button data-testid="menu-toggle" className="md:hidden text-ink" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-white/95 backdrop-blur-xl border-t border-black/5"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <button key={l.label} data-testid={`mobile-nav-${l.label.toLowerCase()}`} onClick={() => go(l.to)} className="text-left font-serif text-2xl text-ink">
                  {l.label}
                </button>
              ))}
              <button data-testid="mobile-nav-cta" onClick={() => { setOpen(false); openDiagnostic(); }} className="mt-2 font-sans text-sm px-5 py-3 rounded-full bg-ink text-stone-50 w-fit">
                Hablemos
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
